import type { RouteClsPayload } from './routeLayoutShiftMeasurement';

const isJsonObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value != null && !Array.isArray(value);

const parseExistingPayload = (payload: string): Record<string, unknown> => {
  let parsedPayload: unknown;

  try {
    parsedPayload = JSON.parse(payload);
  } catch {
    throw new Error('Cannot add route CLS telemetry because the existing page-load payload is not valid JSON.');
  }

  if (!isJsonObject(parsedPayload)) {
    throw new Error('Cannot add route CLS telemetry because the existing page-load payload is not a JSON object.');
  }

  return parsedPayload;
};

export const serializeRouteClsPayload = (routeClsPayload: RouteClsPayload, existingPayload?: string): string => {
  if (existingPayload === undefined) {
    return JSON.stringify({ routeStartToHeroCls: routeClsPayload });
  }

  const parsedPayload = parseExistingPayload(existingPayload);
  if (Object.prototype.hasOwnProperty.call(parsedPayload, 'routeStartToHeroCls')) {
    throw new Error(
      'Cannot add route CLS telemetry because the existing page-load payload already contains routeStartToHeroCls.'
    );
  }

  return JSON.stringify({
    ...parsedPayload,
    routeStartToHeroCls: routeClsPayload,
  });
};
